export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-xl border border-secondary-200/70 p-8 md:p-12">
            <div className="flex-1 w-full text-center md:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                随时随地，追剧不停
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                下载木瓜影视APP，享受更便捷的移动追剧体验。支持离线缓存、夜间模式、智能推荐等功能，让你在任何时间、任何地点都能畅享高清电视剧。
              </p>

              <div className="mt-6 flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
                <a
                  href="#app"
                  className="w-full sm:w-auto px-6 py-3 bg-foreground-900 text-background-50 font-medium rounded-md hover:bg-foreground-800 transition-colors flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer text-sm"
                >
                  <i className="ri-apple-fill text-lg"></i>
                  App Store 下载
                </a>
                <a
                  href="#app"
                  className="w-full sm:w-auto px-6 py-3 bg-foreground-900 text-background-50 font-medium rounded-md hover:bg-foreground-800 transition-colors flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer text-sm"
                >
                  <i className="ri-android-fill text-lg"></i>
                  Android 下载
                </a>
              </div>

              <p className="mt-4 text-xs text-foreground-400">
                支持 iOS 14+ / Android 8+ · 完全免费
              </p>
            </div>

            <div className="w-full max-w-[240px] shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20showing%20a%20streaming%20app%20interface%20with%20TV%20drama%20posters%20and%20warm%20coral%20and%20gold%20themed%20UI%20design%2C%20dark%20mode%20aesthetic%2C%20clean%20minimalist%20layout%2C%20floating%20phone%20on%20dark%20gradient%20background%2C%20no%20text&width=500&height=800&seq=app-mockup-01&orientation=portrait"
                alt="木瓜影视APP移动端展示"
                title="木瓜影视APP-高清电视剧移动追剧"
                className="w-full h-auto rounded-xl object-cover"
                style={{ aspectRatio: '5/8' }}
                onError={(e) => {
                  const target = e.currentTarget;
                  const parent = target.parentElement;
                  if (parent) parent.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}